import React from "react";
import { Form } from "react-final-form";
import { Modal, Table } from "reactstrap";
import CheckboxField from "@/shared/components/form/CheckboxField";

const RemoveSelectedHierarchyModal = ({
  isDeleteHierarchyList,
  toggleDeleteHierarchyList,
  onDeleteHierarchyList,
  deleteHierarchyListData,
  checkedState,
  setCheckedState,
  selectedEventId,
}) => {
  const handleCheckboxChange = (index) => {
    const tmpCheckedState = [...checkedState];
    tmpCheckedState[index].checked = !tmpCheckedState[index].checked;
    setCheckedState(tmpCheckedState);
  };

  return (
    <Modal
      className="manager-program-settings-dialog modal-lg"
      isOpen={isDeleteHierarchyList}
      toggle={toggleDeleteHierarchyList}
      centered
    >
      <div className="manager-program-settings-dialog__header">
        <div className="manager-program-settings-dialog__header-copy">
          <h4 className="manager-program-settings-dialog__title">
            Select programs to delete from
          </h4>
          <p className="manager-program-settings-dialog__description">
            Choose the programs that should lose this event. The current program
            stays selected and cannot be cleared.
          </p>
        </div>
        <button
          type="button"
          className="manager-program-settings-dialog__close"
          onClick={toggleDeleteHierarchyList}
          aria-label="Close"
        >
          Close
        </button>
      </div>
      <div className="manager-program-settings-dialog__body">
        <Form onSubmit={onDeleteHierarchyList}>
          {({ handleSubmit }) => (
            <form className="manager-program-settings-dialog__form" onSubmit={handleSubmit}>
              <div className="manager-program-settings-dialog__table-shell">
                <Table responsive className="manager-program-settings-dialog__table">
                  <thead>
                    <tr>
                      <th>Delete?</th>
                      <th>Event ID</th>
                      <th>Event Name</th>
                      <th>Program Name</th>
                      <th>Event Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deleteHierarchyListData.map((record, index) => (
                      <tr key={record.event_id}>
                        <td>
                          <div className="checkbox-custom2">
                            <CheckboxField
                              name={`action-checkbox-${record.event_id}`}
                              checked={checkedState[index].checked}
                              disabled={
                                checkedState[index].value === Number(selectedEventId)
                              }
                              onChange={() => handleCheckboxChange(index)}
                            />
                          </div>
                        </td>
                        <td>{record.event_id}</td>
                        <td>{record.event_name}</td>
                        <td>{record.program_name}</td>
                        <td>{record.event_type}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <div className="manager-program-settings-dialog__actions">
                <button
                  type="submit"
                  className="manager-program-settings-dialog__action is-danger"
                >
                  Delete selected
                </button>
                <button
                  type="button"
                  className="manager-program-settings-dialog__action"
                  onClick={toggleDeleteHierarchyList}
                >
                  Cancel
                </button>
              </div>
            </form>
          )}
        </Form>
      </div>
    </Modal>
  );
};

export default RemoveSelectedHierarchyModal;
